<template>
    <modal :title=title :show=show :onCancel=onCancel :onSure=onSure height='196'>
         <div class="add-folder" slot="content">
             <h4>文件夹名称</h4>
             <input type="text" v-model="name" maxlength="10">
             <p class="error-info">{{errorTip}}</p>
         </div>
     </modal>
</template>
<script>
import { sortFolders, createOtherFolder, deleteOtherFolder, renameOtherFolder,sysMailCheck } from '@/service/folderService'
export default {
    name: 'addfoleder',
    data() {
        return {
            name:'',
            errorTip:'',
            title:'新建文件夹',
        }
    },
    // props:{
    //     cb:[Function],
    //     rename:{
    //         type: Boolean,
    //         default: false
    //     },
    //     id:[String,Number],
    //     show: {
    //         type: Boolean,
    //         default: false
    //     }
    // },
    beforeDestroy(){
    },
    created(){
        if(this.rename){
            this.title="重命名文件夹"
        }
    },
    watch:{
        name:function(){
            this.errorTip=''
        },
        // rename:function(){
        //     if(this.rename){
        //         this.title="重命名文件夹"
        //     }
        // }
    },
    methods:{
        onCancel(){
            this.show=false
        },
        createFolder(){
            createOtherFolder(this.name.trim()).then((res)=>{
                if(res.status==200){
                    this.$toast({
                        message: '新建文件夹成功',
                        theme: 'success'
                    })
                    this.cb&&this.cb()
                    this.show=false                    
                }else{
                    this.errorTip=res.msg
                }
            }).catch(()=>{
                this.show=false                    
            })
        },
        renameFolder(){
            renameOtherFolder(this.id,this.name.trim()).then((res)=>{
                if(res.status==200){
                    this.$toast({
                        message: '修改文件夹成功',
                        theme: 'success'
                    })
                    this.cb&&this.cb()
                    this.show=false                    
                }else{
                    this.errorTip=res.msg
                }
            }).catch(()=>{
                this.show=false                    
            })
        },
        onSure(){
            if(!this.name.trim()){
                this.errorTip='文件夹名不能为空'
                return 
            }
            if(this.name.trim().length>10){
                this.errorTip='文件夹名字数不能超过10字'                
                return 
            }
            if(this.rename){
                this.renameFolder()
            }else{
                this.createFolder()
            }
            
        }
    }
}
</script>
<style lang="scss" scoped>
.add-folder{
        padding:0 16px;
        h4{
            font-size:12px;
            color: #000;
            text-align:left;
            padding:20px 0 6px;
            margin: 0;
        }
        input{
            width:394px;
            height:32px;
            border:1px solid #d0d0d0;
            font-size: 12px;
            color:#434354;
            padding: 10px;
        }
        .error-info{
            font-size: 12px;
            color: #CC0000;
            text-align:left;
            margin-top:6px;  
            height: 12px;          
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/modal/addfolder.vue